import type { IconProps } from './types';

function Rocket01Icon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  // The artwork is 24x25; the viewBox is padded to a centered square so the icon doesn't distort at any size
  return (
    <svg
      width={size}
      height={size}
      viewBox="-0.5 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M12 7.77699V9.81365M12 15.9237V24.0703M17 19.997H7V6.16198L12 1.07031L17 6.16198V19.997ZM2 14.394L7 11.8503V19.6888L2 22.2325V14.394ZM22 14.394L17 11.8503V19.6888L22 22.2325V14.394Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { Rocket01Icon };
